<template>
    <main-layout>
        <template #submenu>
            <helm-chart-sub-menu :team="team" :chart="chart" active="overview"></helm-chart-sub-menu>
        </template>

        <template #breadcrumbs>
            <span class="union-icon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo-chart-title">
                <inertia-link :href="route('home')">
                    <span class="repo-text">Repositories</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <inertia-link :href="route('repository.view', {team: team})">
                    <span class="repo-text">{{ team.slug }}</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <inertia-link :href="route('helm-chart.view', {team: team, helm_chart: chart})">
                    <span class="repo-text">{{ chart.chart_name }}</span>
                </inertia-link>
                <span class="d-line">/ </span>
                <span>{{ package.version }}</span>

            </span>
        </template>
        <template #pageTitle>
            <h2 class="mb-1">
                <span>{{team.slug}}</span> /
                <span>{{chart.chart_name}}</span> /
                <span>{{package.version}}</span>
            </h2>
            <span class="sm-text">{{ package.description }}</span>
        </template>

        <div class="title-col2">
            <h2 class="mb-3">Install</h2>
        </div>
        <div class="card-style">
            <div class="step-list">
            <ul>
                <li class="li-with-hint">
                    <span>Step 1 Add repo</span>
                    <p>helm repo add {{ team.slug }} {{ route('repository.view', {team: team.slug}) }} --username {{username}} --password [password_or_token]
                        <span class="link-copy link-copy-style"><i class="feather-copy"></i></span></p>
                    <p style="color: #a0a0a0; font-size: 14px; margin-top: 10px">For the password you may use your account password, or an API key. Alternatively you can use deploy token instead of username and password.</p>
                </li>
                <li>
                    <span>Step 2 Install application</span>
                    <p>helm install {{chart.chart_name}} {{team.slug}}/{{chart.chart_name}}<span class="link-copy link-copy-style"><i class="feather-copy"></i></span></p>
                </li>
            </ul>
            </div>
        </div>
        <div class="readme-wrap">
            <div class="title-col2">
                <h2 class="mb-3">Readme</h2>
            </div>
            <div v-if="readme" v-html="readme" class="readme"></div>
            <div v-else class="card-style">
                <p>Include a README.md file into your chart. Its contents will be displayed here. Use markdown to format the document content.</p>
            </div>
        </div>

        <template #rightSidebar>
            <div class="col-lg-auto">
                <div class="siderbar-right sidebar-style">
                    <div class="sidebar-link">
                        <h4>CHART METADATA</h4>
                        <div class="sidebar-chart-content">
                            <div class="row gy-1">
                                <div class="col-4">
                                    <span>AppVersion</span>
                                </div>
                                <div class="col-7">
                                    <span class="fw_medium">{{package.app_version}}</span>
                                </div>
                                <div class="col-4">
                                    <span>Version</span>
                                </div>
                                <div class="col-7">
                                    <span class="fw_medium">{{package.version}}</span>
                                </div>
                                <div class="col-4" v-if="package.tags">
                                    <span>Tags</span>
                                </div>
                                <div class="col-7" v-if="package.tags">
                                    <span class="fw_medium">{{ package.tags }}</span>
                                </div>
                                <div class="col-4">
                                    <span>Released</span>
                                </div>
                                <div class="col-7">
                                    <span class="fw_medium">{{dateFormating(package.updated_at)}}</span>
                                </div>
                            </div>
                        </div>
                        <h4>SOURCE</h4>
                        <ul v-if="package.sources">
                            <li>
                                <a :href="route('helm.chart_package.download', {team: team, helm_chart: chart, helm_chart_package: package })">
                                    <span class="lg-icon"><i class="demo-icon icon-download-icon"></i></span>
                                    <span>Download chart</span>
                                </a>
                            </li>
                            <li v-for="source in JSON.parse(package.sources)">
                                <a :href="source" target="_blank">
                                    <span class="lg-icon"><i class="demo-icon icon-git-icon"></i></span>
                                    <span>{{ source.replace('https://', '') }}</span>
                                </a>
                            </li>
                        </ul>
                        <h4>DOCKER IMAGES</h4>
                        <ul v-if="package.docker_images">
                            <li v-for="image in JSON.parse(package.docker_images)">
                                <a :href="dockerImageUrl(image)" target="_blank">
                                    <span class="lg-icon"><i class="demo-icon icon-dockerhub-icon"></i></span>
                                    <span>{{ image }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from "@/Layouts/MainLayout";
    import HelmChartSubMenu from "@/Components/HelmChartSubMenu";

    export default {
        name: "Overview",
        components: {HelmChartSubMenu, MainLayout},
        props: ['team', 'chart', 'package', 'username', 'readme'],
        methods: {
            dateFormating(date) {
                let newDate = new Intl.DateTimeFormat('en-GB', {dateStyle: 'medium'}).format(new Date(date));
                return newDate;
            },
            dockerImageUrl(image) {
                let [name, version] = image.split(':');

                if (image.split('/').length == 2) {
                    return 'https://hub.docker.com/r/' + name;
                }
                else if (image.split('/').length == 1) {
                    return 'https://hub.docker.com/_/' + name;
                }
                else {
                    return 'https://' + name;
                }
            }
        }
    }
</script>

<style scoped>

</style>
